import { MAX_BADGE_COUNT } from "../constants";

export function formatBadgeCount(count) {
  if (!Number.isFinite(count) || count <= 0) return null;
  return count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(count);
}
